import group from './group'
import user from './user'

const management = {
  group, user
}

export default management